import { Link } from 'react-router-dom';
import { FaqSectionView } from '../components/FaqSectionView';
import { FAQ_SECTIONS } from '../lib/faqContent';
import { useDocumentTitle } from '../lib/useDocumentTitle';

export default function FAQScreen() {
  useDocumentTitle('Help & FAQ');
  return (
    <div className="min-h-dvh safe-top safe-bottom container-app pb-12">
      <header className="flex items-center gap-3 pt-4 pb-2">
        <Link
          to="/me"
          aria-label="Back"
          className="rounded-full inline-flex items-center justify-center"
          style={{ minWidth: 44, minHeight: 44, color: 'var(--color-primary)' }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </Link>
        <h1 className="text-xl font-semibold" style={{ letterSpacing: '-0.01em' }}>
          Help &amp; FAQ
        </h1>
      </header>

      <p style={{ color: 'var(--color-text-secondary)', fontSize: 14, lineHeight: 1.5, marginTop: 4, marginBottom: 18 }}>
        Quick answers for using Menu to Menu safely abroad. If you have a severe allergy, start with the{' '}
        <Link to="/safety" style={{ color: 'var(--color-danger)', textDecoration: 'underline', fontWeight: 600 }}>
          Safety guide
        </Link>.
      </p>

      <nav
        aria-label="FAQ sections"
        style={{
          marginBottom: 24,
          padding: '12px 14px',
          borderRadius: 10,
          background: 'var(--color-surface)',
        }}
      >
        <p
          style={{
            fontSize: 11,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: 'var(--color-text-secondary)',
            margin: '0 0 8px',
            fontWeight: 600,
          }}
        >
          Jump to
        </p>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {FAQ_SECTIONS.map((s) => (
            <li key={s.id}>
              <a
                href={`#${s.id}`}
                style={{
                  display: 'inline-block',
                  fontSize: 13,
                  padding: '4px 10px',
                  borderRadius: 9999,
                  border: '1px solid var(--color-divider)',
                  color: 'var(--color-primary)',
                  textDecoration: 'none',
                  background: 'transparent',
                }}
              >
                {s.title}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      {FAQ_SECTIONS.map((s) => (
        <FaqSectionView key={s.id} section={s} />
      ))}

      <p
        style={{
          marginTop: 8,
          paddingTop: 24,
          borderTop: '1px solid var(--color-divider)',
          color: 'var(--color-text-secondary)',
          fontSize: 13,
          textAlign: 'center',
          lineHeight: 1.6,
        }}
      >
        Still stuck or found a bug? Use your phone's share menu to send the page URL with a note —
        screenshots and language pair help most.
      </p>
    </div>
  );
}
